import React, { useState } from "react";
import { postRequest } from "../../services/mainApp.service";
import { Loader2, Plus, Minus } from "lucide-react";

const DeliveryTimeCounter = ({ initialMinutes, record, userData }) => {
    console.log("Initial Minutes:", initialMinutes);
  const [minutes, setMinutes] = useState(initialMinutes);
  const [loading, setLoading] = useState(false);

  const updateDeliveryTime = async (operator) => {
    if (!record || !record?.OrderMasterId) return;

    setLoading(true);
    try {
      await postRequest("UpdateOrderDeliveryTime", {
        OperationId: 3, // 👈 
        CompanyId: userData?.CompanyId,
        OrderMasterId: record?.OrderMasterId,
        Minutes: operator === "+" ? +5 : -5, // send +5 or -5,
        UserId: userData?.UserId,
      }).then((response) => {
       setMinutes(response?.data?.DataSet?.Table1[0]?.DeliveryTime);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });

      setMinutes(newMinutes);
    } catch (error) {
      console.error("Error updating delivery time:", error);
    } finally {
      setLoading(false);
    }
  };

const handleIncrement = () => updateDeliveryTime("+");
const handleDecrement = () => {
  if (minutes > 5) updateDeliveryTime("-");
};

  return (
    <div className="flex-1 flex justify-center items-center gap-3 p-3   rounded-2xl bg-white">
  {/* Decrement Button */}
  <button
    onClick={handleDecrement}
    disabled={loading || minutes <= 5}
    className="p-2 bg-red-50 rounded-full hover:bg-red-100 border border-red-200 transition disabled:opacity-40 disabled:cursor-not-allowed"
  >
    <Minus className="text-red-600 w-6 h-6" />
  </button>

  {/* Delivery Time Display */}
  <div className="flex flex-col items-center justify-center min-w-[100px] text-center">
    {loading ? (
      <Loader2 className="animate-spin w-7 h-7 text-gray-500" />
    ) : (
      <>
        <div className="text-2xl font-semibold text-gray-900 tracking-wide">
          {minutes} min
        </div>
        <span className="text-sm text-gray-500 ">
          Delivery Time
        </span>
      </>
    )}
  </div>

  {/* Increment Button */}
  <button
    onClick={handleIncrement}
    disabled={loading}
    className="p-2 bg-green-50 rounded-full hover:bg-green-100 border border-green-200 transition disabled:opacity-40 disabled:cursor-not-allowed"
  >
    <Plus className="text-green-600 w-6 h-6" />
  </button>
</div>

  );
};

export default DeliveryTimeCounter;
